export default __webpack_public_path__ + "static/summer_containers30-8a5acbf8cfba62cb260ce8121f90e91e.webp";